export const CS_AUTH0_CLIENT_CONNECTION = 'highmark-internal-enterprise-saml';
export const CS_TOKEN_CLAIM_KEY_MEMBER_ID =
  'https://el/latest_member_league_user_id';
